import React from "react";
import styled from "styled-components";
import { Theme } from "./Theme";
import { LoadSpinner } from "./LoadSpinner";
import { AnimatePresence, motion } from "framer-motion";

type FullscreenLoaderProps = {
  text?: string;
};

export const FullscreenLoader: React.FC<FullscreenLoaderProps> = ({ text }) => {
  return (
    <StyledWrap>
      <LoadSpinner size={40} color={Theme.colors.accentColor} />

      <StyledTextWrap>
        <AnimatePresence mode="wait" initial={false}>
          {text && (
            <StyledText
              key={text}
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -6 }}
              transition={{ duration: 0.2, ease: "easeOut" }}
            >
              {text}
            </StyledText>
          )}
        </AnimatePresence>
      </StyledTextWrap>
    </StyledWrap>
  );
};

const StyledWrap = styled.div`
  min-height: 100dvh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  background: ${Theme.colors.pageBgColor};

  @supports not (height: 100dvh) {
    min-height: 100vh;
  }
`;

const StyledTextWrap = styled.div`
  min-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledText = styled(motion.div)`
  color: ${Theme.colors.secondaryFontColor};
  font-size: ${Theme.font.fontSize4};
  text-align: center;
`;
